import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import ClipboardButton from 'react-clipboard.js';

import iconLink from 'assets/images/icons/icon-link-dark.svg';
import iconCheck from 'assets/images/icons/check-icon.svg';
import Modal from 'components/Modal';

import styles from './ShareLotDialog.scss';
import { useTranslation } from 'react-i18next';
import { makeBase64 } from '../Building/Main/helper';
// import tracker from '../../services/tracker';
import CheckboxSwitcher from '../common/CheckboxSwitcher';
import { ROOT_URL } from '../../constants/Config';
// import { gaEvent, trackGA } from 'services/ga';

const ShareLotDialog = ({ onClose, shareId, building, objectType, profile, lotId }) => {
  // const [showNotification, setShowNotification] = useState(false);
  const [values, setValues] = useState({
    nameAddress: true,
    description: true,
    characteristics: true,
    communications: false,
    checkout: false,
    payment: false,
    contacts: true,
  });
  // const [url, setUrl] = useState('');
  const [hash, setHash] = useState('');
  const { t } = useTranslation();

  // const handleTrackEvent = ({ eventName, eventLabel, eventContent }) => {
  //   const { title, id } = building;
  //   trackGA(
  //     gaEvent[eventName]({
  //       eventLabel,
  //       eventContent: eventContent || title,
  //       productType: objectType,
  //       productName: title,
  //       productID: id,
  //       user_id: profile.id,
  //     })
  //   );
  // };

  useEffect(
    () => () => {
      // handleTrackEvent({
      //   eventName: 'buildingShareButtonsClick',
      //   eventLabel: 'zakryt',
      // });
    },
    []
  );

  const handleInputFocus = (e) => {
    e.target.selectionStart = 0;
    e.target.selectionEnd = e.target.value.length;

    // tracker.sendEvent('Web_ShareDialog_Link');
  };

  const handleClipboardClick = () => {
    // setShowNotification(true);
    // tracker.sendEvent('Web_ShareDialog_CopyButton');
    // handleTrackEvent({
    //   eventName: 'buildingShareButtonsClick',
    //   eventLabel: 'skopirovat',
    // });
    // setTimeout(() => this.setState({ showNotification: false }), 5000);
  };

  const handlePdfClick = () => {
    // tracker.sendEvent('Web_ShareDialog_SavePdf', {
    //   id: building.data.id,
    //   name: building.data.title,
    // });

    // handleTrackEvent({
    //   eventName: 'buildingShareButtonsClick',
    //   eventLabel: 'skachat_prezentaciyu',
    // });

    const link = document.createElement('a');
    link.href = `${ROOT_URL}/share-lot/pdf/${hash}`;
    link.download = 'file.pdf';
    link.target = '__blank';
    link.dispatchEvent(new MouseEvent('click'));
    link.remove();
  };

  const handleChange = (name, value, text) => {
    // tracker.sendEvent(`Web_ShareDialog_${firstLetterToUpper(name)}`, {
    //   selected: value,
    // });

    // handleTrackEvent({
    //   eventName: 'buildingShareCheckboxesPick',
    //   eventContent: [text, ` | ${value ? 'on' : 'off'}`],
    // });

    setValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    makeBase64({
      id: shareId,
      values,
    }).then((hashValue) => {
      setHash(hashValue);
      // setUrl(`${window.location.origin}/nbref/${hashValue}`);
    });
  }, [values]);

  return (
    <Modal
      isOpen
      handleClose={onClose}
      title={t('components.building.chess.sendLot')}
      contentStyle={{
        width: '526px',
        margin: 'auto',
      }}
    >
      <div className={styles.Modal}>
        <p className={styles.ModalDescription}>{t('components.shareDialog.title')}</p>
        <div className={styles.ModalCheckboxes}>
          <CheckboxSwitcher
            enabled={values.nameAddress}
            onToggle={() => handleChange('nameAddress', !values.nameAddress, 'Название и адрес')}
            text={t('components.shareDialog.nameAndAddress')}
          />
          <CheckboxSwitcher
            enabled={values.description}
            onToggle={() =>
              handleChange('description', !values.description, 'Описание и преимущества')
            }
            text={t('components.shareDialog.descriptionAndAdvantages')}
          />
          <CheckboxSwitcher
            enabled={values.characteristics}
            onToggle={() =>
              handleChange('characteristics', !values.characteristics, 'Общие характеристики')
            }
            text={t('components.shareDialog.mainInfo')}
          />
          <CheckboxSwitcher
            enabled={values.communications}
            onToggle={() => handleChange('communications', !values.communications, 'Коммуникации')}
            text={t('components.shareDialog.communications')}
          />
          <CheckboxSwitcher
            enabled={values.checkout}
            onToggle={() => handleChange('checkout', !values.checkout, 'Оформление')}
            text={t('components.shareDialog.documents')}
          />
          <CheckboxSwitcher
            enabled={values.payment}
            onToggle={() => handleChange('payment', !values.payment, 'Оплата')}
            text={t('components.shareDialog.payments')}
          />
          <CheckboxSwitcher
            enabled={values.contacts}
            onToggle={() => handleChange('contacts', !values.contacts, 'Мои контакты')}
            text={t('components.shareDialog.myContacts')}
          />
        </div>
        {/* <div className={styles.SendCollectionInputWrap}>
          <img src={iconLink} alt="" />
          <input
            readOnly
            value={url}
            className={styles.SendCollectionInput}
            onFocus={handleInputFocus}
          />
        </div> */}

        <button className={cn(styles.SendPdf)} onClick={handlePdfClick}>
          {t('components.shareDialog.savePdfFile')}
        </button>

        {/* {showNotification ? (
          <span className={styles.ModalNotification}>
            <img src={iconCheck} alt={t('components.shareDialog.copied')} />{' '}
            {t('components.shareDialog.copied')}
          </span>
        ) : null} */}
      </div>
    </Modal>
  );
};

export default React.memo(ShareLotDialog);



// WEBPACK FOOTER //
// ./src/components/ShareLotDialog/ShareLotDialog.js